module.exports = "<span class=inp-subtle> <span class=inp-subtle-span v-text=\"(model||placeholder)+'.'\"></span> <textarea type=text v-model=model :placeholder=placeholder></textarea> </span>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextareaSubtle.vue
 ** module id = 144
 ** module chunks = 0
 **/